<div style="display: flex; flex-direction: column; height: 100%; background-color: white; border: 1px solid #879BA8; border-radius: 8px; padding: 32px;">
    <div class="criterionTypeTitleTour">
        <p style="font-size: 24px; font-weight: 600; margin: 0 0 12px;">
            {{getCriterionTypeTitle()}}
        </p>
        <p style="font-size: 16px;" *ngIf="currentTypeCriterion !== 'companySizes' && currentTypeCriterion !== 'donneesChiffrees'">{{getCriterionTypeSubTitle()}}</p>
        <!-- Option "données institutionnelles" : les articles institutionnels ne remontent que si la recherche contient un critère déclencheur -->
        <p class="institutional-help" *ngIf="hasInstitutionalData && (currentTypeCriterion === 'decisionsAdmin' || currentTypeCriterion === 'sourceOrigins')">
            Les articles issus de sources institutionnelles n'apparaissent que dans les recherches contenant une décision administrative ou une origine «&nbsp;Sources institutionnelles&nbsp;».
        </p>
        <p class="institutional-help" *ngIf="hasInstitutionalData && currentTypeCriterion === 'donneesChiffrees'">
            Ces données concernent surtout les articles issus de sources institutionnelles, qui n'apparaissent que dans les recherches contenant une décision administrative ou une origine «&nbsp;Sources institutionnelles&nbsp;».
        </p>

        <fe-button [text]="getGuideLeadBtnText()" type="SECONDARY" icon="true" [iconType]="IconType.tour"
                   (click)="launchTemporalTour()" smallButton="true" style="margin-bottom: 16px; display: flex;"
                   bold="true" [class.displayNone]="this.currentTypeCriterion != 'topics'" class="feTourBorderBtn"/>

        <fe-button text="Guide sur l'utilisation de la recherche mots clés" type="SECONDARY" icon="true"
                   (click)="launchTour.emit(this.currentTypeCriterion);" class="feTourBorderBtn"
                   style="margin-bottom: 16px; display: flex;" [iconType]="IconType.tour" smallButton="true"
                   bold="true" [class.displayNone]="this.currentTypeCriterion != 'keywords'"/>
    </div>

    <ng-container *ngIf="currentTypeCriterion === 'keywords'">
        <mat-form-field class="keywordsInput">
            <mat-label>Tous les mots suivants</mat-label>
            <mat-chip-grid #mustGrid style="max-height: 115px;overflow: auto;">
                <mat-chip-row *ngFor="let keyword of keywords.must"
                  (removed)="remove(keyword, 'must')"
                  [editable]="true"
                  (edited)="edit(keyword, $event, 'must')">
                {{keyword}}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
                <input placeholder="Ajouter vos mots-clés"
                       [matChipInputFor]="mustGrid"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="addOnBlur"
                       (matChipInputTokenEnd)="add($event, 'must')"/>
            </mat-chip-grid>
        </mat-form-field>
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 22px;">
            <span>Avec</span>
            <div style="border: 1px solid black; flex: 1;"></div>
        </div>
        <mat-form-field class="keywordsInput">
            <mat-label>Un des mots suivant</mat-label>
            <mat-chip-grid #shouldGrid style="max-height: 115px;overflow: auto;">
                <mat-chip-row *ngFor="let keyword of keywords.should"
                              (removed)="remove(keyword, 'should')"
                              [editable]="true"
                              (edited)="edit(keyword, $event, 'should')">
                    {{keyword}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
                <input placeholder="Ajouter vos mots-clés"
                       [matChipInputFor]="shouldGrid"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="addOnBlur"
                       (matChipInputTokenEnd)="add($event, 'should')"/>
            </mat-chip-grid>
        </mat-form-field>
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 22px;">
            <span>Avec</span>
            <div style="border: 1px solid black; flex: 1;"></div>
        </div>
        <mat-form-field class="keywordsInput">
            <mat-label>Aucun des mots suivants</mat-label>
            <mat-chip-grid #mustNotGrid style="max-height: 115px;overflow: auto;">
                <mat-chip-row *ngFor="let keyword of keywords.mustNot"
                              (removed)="remove(keyword, 'mustNot')"
                              [editable]="true"
                              (edited)="edit(keyword, $event, 'mustNot')">
                    {{keyword}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
                <input placeholder="Ajouter vos mots-clés"
                       [matChipInputFor]="mustNotGrid"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="addOnBlur"
                       (matChipInputTokenEnd)="add($event, 'mustNot')"/>
            </mat-chip-grid>
        </mat-form-field>
    </ng-container>

    <ng-container *ngIf="currentTypeCriterion === 'donneesChiffrees'">
        <div style="overflow: auto; display: flex; flex-direction: column; padding-right: 16px;">
            <p *ngIf="getMetricsTypes().length === 0" style="font-size: 16px;">Aucune donnée chiffrée disponible.</p>
            <div *ngFor="let metricsType of getMetricsTypes(); let typeIndex = index" style="margin-top: 15px; margin-bottom: 15px;">
                <div class="metrics-types-separator" *ngIf="getActiveMetricsCount(metricsType) > 0 && hasPreviousActiveMetricsType(typeIndex)">
                    <span class="metrics-types-separator-label">ET</span> — les types se combinent toujours entre eux
                </div>
                <div class="metrics-type-header">
                    <p style="font-size: 24px; font-weight: 600; margin: 0;">
                        {{metricsType.name}}
                    </p>
                    <div class="metrics-operator" *ngIf="getActiveMetricsCount(metricsType) >= 2" role="group" aria-label="Combinaison des filtres">
                        <button type="button" [class.active]="getMetricsOperator(metricsType) === 'and'"
                                [attr.aria-pressed]="getMetricsOperator(metricsType) === 'and'"
                                (click)="setMetricsOperator(metricsType, 'and')">Tous les filtres (ET)</button>
                        <button type="button" [class.active]="getMetricsOperator(metricsType) === 'or'"
                                [attr.aria-pressed]="getMetricsOperator(metricsType) === 'or'"
                                (click)="setMetricsOperator(metricsType, 'or')">Au moins un (OU)</button>
                    </div>
                </div>
                <ng-container *ngFor="let qualifier of metricsType.qualifiers">
                    <div *ngIf="getMetricFilter(qualifier) as metricFilter" style="margin-bottom: 15px;">
                        <mat-checkbox style="display: block" [(ngModel)]="metricFilter.active" (ngModelChange)="onMetricChange()">
                            Filtrer sur {{qualifier.name | lowercase}}{{qualifier.units ? ' (en ' + qualifier.units + ')' : ''}}
                        </mat-checkbox>
                        <div style="border: 1px solid grey;
                                    border-radius: 5px;
                                    margin-top: 10px;
                                    margin-bottom: 10px;
                                    padding-left: 10px;">
                            <div style="display: flex;
                                    flex-direction: row;
                                    align-items: center">
                                <div style="width: 55px">{{formatMetricValue(qualifier, metricFilter.indexMin)}}</div>
                                <mat-slider step="1" showTickMarks="true" [disabled]="!metricFilter.active" style="margin: 10px 30px; width: 350px" min="0" [max]="metricFilter.sliderValues.length - 1">
                                    <input matSliderStartThumb [(ngModel)]="metricFilter.indexMin" (ngModelChange)="onMetricChange()">
                                    <input matSliderEndThumb [(ngModel)]="metricFilter.indexMax" (ngModelChange)="onMetricChange()">
                                </mat-slider>
                                <div style="width: 100px">{{formatMetricValue(qualifier, metricFilter.indexMax)}}</div>
                            </div>
                            <mat-checkbox style="display: block; margin-left: 10px; margin-bottom: 10px" [disabled]="!metricFilter.active" [(ngModel)]="metricFilter.includeNull" (ngModelChange)="onMetricChange()">Inclure les articles sans informations</mat-checkbox>
                        </div>
                    </div>
                </ng-container>
                <p class="metrics-type-sentence" *ngIf="getActiveMetricsCount(metricsType) > 0">{{getMetricsTypeSentence(metricsType)}}</p>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isCriterionType()">
<!--        <ion-searchbar show-clear-button="never" matInput placeholder="Rechercher dans la liste" (input)="filterCriterions($event.target.value)"></ion-searchbar>-->

        <fe-searchbar [(value)]="currentFilter" style="margin-bottom: 10px" (valueChange)="filterCriterions($event)" *ngIf="currentTypeCriterion !== 'companySizes'"/>

        <ng-container *ngIf="currentTypeCriterion === 'locations' && geolocSearchAvailable">
            <div *ngIf="!geoloc || geoloc.geolocDistanceRadius === null" style="display: flex;flex-direction: row; padding: 5px 0 20px 0;">
                <fe-icon [iconType]="IconType.localisations" class="categoryIcon"/>
                <a style="cursor:pointer;margin-left: 5px; font-weight: bold; " (click)="openGeoloc()">Utiliser une géolocalisation</a>
            </div>
            <div *ngIf="geoloc && geoloc.geolocDistanceRadius != null" style="padding: 5px 0 10px 0;">
                <div style="display: flex;flex-direction: row;">
                    <fe-icon [iconType]="IconType.localisations" class="categoryIcon"/>
                    <div style="flex:1; font-weight: bold; text-decoration: underline; margin-left: 5px;">Géolocalisation appliquée</div>
                </div>
                <div style="margin-bottom: 10px;margin-top: 5px;display: flex; flex-direction: row; align-items: center; color:#475A66;"><div>{{geoloc.cityName + ' - Rayon de ' + geoloc.geolocDistanceRadius + 'km'}}</div><div class="CloseButton"><mat-icon style="cursor: pointer" (click)="removeGeoloc()">close</mat-icon></div></div>
            </div>
        </ng-container>

        <mat-checkbox (change)="selectDeselectAll($event)" [checked]="allChecked()" class="checkAll" *ngIf="currentTypeCriterion !== 'companySizes'">
            Sélectionner / Désélectionner tout
        </mat-checkbox>

        <mat-accordion style="overflow: auto;" multi="true" *ngIf="currentTypeCriterion !== 'companySizes'">
            <app-criterion-item-panel *ngFor="let criterion of currentCriterions" [leadsAvailable]="leadsAvailable" [criterionType]="currentTypeCriterion" [criterion]="criterion" (emitter)="changeCriterionSelection()" [filter]="currentFilter"
                                      [expandedByDefault]="currentTypeCriterion === 'sourceOrigins'">

            </app-criterion-item-panel>
        </mat-accordion>

        <ng-container *ngIf="currentTypeCriterion === 'companySizes'">
            <div style="margin-top: 15px; margin-bottom: 15px;">
                <p style="font-size: 24px; font-weight: 600; margin: 0 0 12px;">
                    Effectifs
                </p>
                <mat-checkbox style="display: block" [(ngModel)]="entrepriseData.effectifActive" (ngModelChange)="onEffectifCheck();onEffectifChange()">Filtrer sur les effectifs</mat-checkbox>
                <div style="border: 1px solid grey;
                            border-radius: 5px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            padding-left: 10px;">
                    <div style="display: flex;
                            flex-direction: row;
                            align-items: center">
                        <div style="width: 55px" #labelCaMin> {{formatNumber(sliderEffectifValues[sliderEffectifIndexMin])}}</div>
<!--                        <mat-slider [disabled]="!entrepriseData.effectifActive" #sliderEffectif discrete style="margin: 10px 30px; width: 500px" max="120000" min="0">-->
<!--                            <input matSliderStartThumb [(ngModel)]="entrepriseData.effectifMin" (ngModelChange)="onEffectifChange()">-->
<!--                            <input matSliderEndThumb [(ngModel)]="entrepriseData.effectifMax" (ngModelChange)="onEffectifChange()">-->
<!--                        </mat-slider>-->
                        <mat-slider step="1" showTickMarks="true" [disabled]="!entrepriseData.effectifActive" #sliderEffectif style="margin: 10px 30px; width: 350px" max="11" min="0">
                            <input matSliderStartThumb [(ngModel)]="sliderEffectifIndexMin" (ngModelChange)="onEffectifChange()">
                            <input matSliderEndThumb [(ngModel)]="sliderEffectifIndexMax" (ngModelChange)="onEffectifChange()">
                        </mat-slider>
                        <div style="width: 100px" #labelCaMax>{{formatNumber(sliderEffectifValues[sliderEffectifIndexMax])}}</div>
                    </div>
                    <mat-checkbox style="display: block; margin-left: 10px; margin-bottom: 10px" [disabled]="!entrepriseData.effectifActive" [(ngModel)]="entrepriseData.effectifNull" (ngModelChange)="onEffectifChange()">Inclure les articles sans informations</mat-checkbox>
                </div>
            </div>
            <div style="margin-top: 15px; margin-bottom: 15px;">
                <p style="font-size: 24px; font-weight: 600; margin: 0 0 12px;">
                    Chiffre d'affaires (en milliers d'euros)
                </p>
                <mat-checkbox style="display: block" [(ngModel)]="entrepriseData.caActive" (ngModelChange)="onCaCheck();onEffectifChange()">Filtrer sur le chiffre d'affaire</mat-checkbox>
                <div style="border: 1px solid grey;
                            border-radius: 5px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            padding-left: 10px;">
                    <div style="display: flex;
                            flex-direction: row;
                            align-items: center">
                        <div style="width: 55px" #labelCaMin> {{caFormat(entrepriseData.chiffreDaffaireMin)}}</div>
                       <mat-slider step="1" showTickMarks="true" [disabled]="!entrepriseData.caActive" #sliderCa style="margin: 10px 30px; width: 350px" max="11" min="0">
                            <input matSliderStartThumb [(ngModel)]="sliderCaIndexMin" (ngModelChange)="onEffectifChange()">
                            <input matSliderEndThumb [(ngModel)]="sliderCaIndexMax" (ngModelChange)="onEffectifChange()">
                        </mat-slider>
                        <div style="width: 100px" #labelCaMax>{{caFormat(entrepriseData.chiffreDaffaireMax)}}</div>
                    </div>
                    <mat-checkbox style="display: block; margin-left: 10px; margin-bottom: 10px" [disabled]="!entrepriseData.caActive" [(ngModel)]="entrepriseData.caNull" (ngModelChange)="onEffectifChange()">Inclure les articles sans informations</mat-checkbox>
                </div>
            </div>
            <div style="margin-top: 15px; margin-bottom: 15px;">
                <p style="font-size: 24px; font-weight: 600; margin: 0 0 12px;">
                    Code NAF
                </p>
                <mat-form-field class="w-full" appearance="outline" style="width: 100%">
                    <mat-chip-grid #chipGrid style="height: 100px;overflow: auto;">
                        <mat-chip-row
                                *ngFor="let item of entrepriseData.codeApes"
                                [removable]="true"
                                (removed)="removeApe(item)">
                            {{ item.code  + ' - ' +  item.label }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input
                        #input
                        #trigger="matAutocompleteTrigger"
                        placeholder="Rechercher..."
                        [formControl]="inputCtrl"
                        [matChipInputFor]="chipGrid"
                        [matAutocomplete]="auto"/>
<!--                        matAutocompletePosition="below"/>-->
                    <mat-autocomplete
                        #auto="matAutocomplete"
                        (optionSelected)="select($event.option.value, input, trigger)">
                        <mat-option
                                *ngFor="let option of suggestions$ | async"
                                [value]="option">
                            {{ option.code  + ' - ' +  option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </ng-container>
    </ng-container>
</div>
